// SLA #12: a quotation's customer must be picked from the existing accounts list.
// The backend enforces this; these helpers give the user the same message up front.

export const CUSTOMER_NOT_IN_LIST_MSG =
  'Select the customer from the dropdown list. Manually typed customer names cannot be saved.';

const norm = (s) => String(s || '').trim().toLowerCase();

export const isKnownCustomer = (name, accountNames = []) =>
  accountNames.some((n) => norm(n) === norm(name));

// Show the hint only for a typed value that is not an account. An unchanged
// customer on an existing quote (originalName) is accepted, like the backend.
export const showCustomerHint = (name, accountNames, originalName = '') =>
  !!String(name || '').trim() &&
  accountNames.length > 0 &&
  !isKnownCustomer(name, accountNames) &&
  norm(name) !== norm(originalName);
